import type { TooltipProps } from '@mui/material';

/**
 * Keeps a tooltip 16px clear of the screen edge. The control center's buttons sit against the
 * right edge, and by default a tooltip only shifts far enough to stay on screen — flush against it.
 */
export const EDGE_SAFE_TOOLTIP: TooltipProps['slotProps'] = {
  popper: { modifiers: [{ name: 'preventOverflow', options: { padding: 16 } }] },
};
